import React from 'react';
import { string } from 'prop-types';
import IconWrapper from '../IconWrapper';
import Messages from '../../Messages';

const SellerNotifications = ({ username }) => (
    <IconWrapper>
        <Messages username={username} drawerType={Messages.DRAWER_TYPES.NOTIFICATIONS} showAsIcons />
    </IconWrapper>
);

SellerNotifications.propTypes = {
    username: string.isRequired,
};

export default SellerNotifications;
